/* eslint-disable no-template-curly-in-string */
import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let trimExample = `str="   padded value   "

# Strip leading whitespace
str="$\{str#"$\{str%%[![:space:]]*}"}"
# Strip trailing whitespace
str="$\{str%"$\{str##*[![:space:]]}"}"

echo "[$str]"
# [padded value]`

export default function StringManipulation() {
    return (
        <div className={globalStyles.article}>
            <h1>String manipulation</h1>
            <p>Bash can do most day-to-day string work with built-in parameter expansion — no need to shell out
                to <code>sed</code>/<code>awk</code> for simple cases.</p>

            <h3>Length, substrings & case</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '500px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Result</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>{"${#str}"}</code></td>
                        <td>Length of <code>str</code></td>
                    </tr>
                    <tr>
                        <td><code>{"${str:5}"}</code></td>
                        <td>Substring starting at index 5</td>
                    </tr>
                    <tr>
                        <td><code>{"${str:5:3}"}</code></td>
                        <td>3 characters starting at index 5</td>
                    </tr>
                    <tr>
                        <td><code>{"${str: -5}"}</code></td>
                        <td>Last 5 characters (space before <code>-</code> is required)</td>
                    </tr>
                    <tr>
                        <td><code>{"${str,,}"}</code></td>
                        <td>Lowercase everything</td>
                    </tr>
                    <tr>
                        <td><code>{"${str^^}"}</code></td>
                        <td>Uppercase everything</td>
                    </tr>
                    <tr>
                        <td><code>{"${str^}"}</code></td>
                        <td>Uppercase first character</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Replace & trim</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '500px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Result</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>{"${str/foo/bar}"}</code></td>
                        <td>Replace first match of <code>foo</code> with <code>bar</code></td>
                    </tr>
                    <tr>
                        <td><code>{"${str//foo/bar}"}</code></td>
                        <td>Replace all matches</td>
                    </tr>
                    <tr>
                        <td><code>{"${str#prefix}"}</code></td>
                        <td>Strip shortest matching prefix</td>
                    </tr>
                    <tr>
                        <td><code>{"${str##prefix}"}</code></td>
                        <td>Strip longest matching prefix</td>
                    </tr>
                    <tr>
                        <td><code>{"${str%suffix}"}</code></td>
                        <td>Strip shortest matching suffix</td>
                    </tr>
                    <tr>
                        <td><code>{"${str%%suffix}"}</code></td>
                        <td>Strip longest matching suffix</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Example — swap a file extension</h3>
            <pre className={globalStyles.code}>
                <code>
                    file="report.txt"<br/>
                    {"echo \"${file%.txt}.pdf\""}<br/>
                    <span style={{opacity: 0.7}}># report.pdf</span>
                </code>
            </pre>

            <h3>Example — trim whitespace</h3>
            <SyntaxHighlighter
                children={trimExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
